export const formatMAC = (value) => {
  // Remove tudo que não é letra ou número (permite A-Z, 0-9)
  const cleaned = value.replace(/[^0-9A-Za-z]/g, '');
  
  // Add colon every 2 characters
  const parts = [];
  for (let i = 0; i < cleaned.length; i += 2) {
    if (i < 12) {
      parts.push(cleaned.substr(i, 2));
    }
  }
  
  return parts.join(':').toUpperCase();
};

export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatDateOnly = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};

export const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
};

// Format credits with infinity symbol for admin
export const formatCredits = (value, userRole) => {
  if (userRole === 'admin') {
    return '∞';
  }
  return formatCurrency(value);
};

export const getStatusColor = (status) => {
  switch (status?.toLowerCase()) {
    case 'ativado':
    case 'active':
      return 'bg-green-100 text-green-800';
    case 'pendente':
      return 'bg-yellow-100 text-yellow-800';
    case 'solicitado':
      return 'bg-orange-100 text-orange-800 animate-pulse';
    case 'incorreto':
    case 'blocked':
    case 'banned':
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const getStatusLabel = (status) => {
  const labels = {
    'active': 'Ativo',
    'blocked': 'Bloqueado',
    'banned': 'Banido',
    'ativado': 'Ativado',
    'pendente': 'Pendente',
    'solicitado': 'Solicitado',
    'incorreto': 'Incorreto'
  };
  return labels[status?.toLowerCase()] || status;
};
